import {
  DEMO_PATH,
  FEEDBACK_PATH,
  HELP_PATH,
  PRIVACY_PATH,
  TERMS_PATH,
} from "@/pages/paths";
import { Trans } from "@lingui/react/macro";
import { useMemo } from "react";
import { Link } from "react-router-dom";

export function AppFooter() {
  const year = useMemo(() => new Date().getFullYear(), []);

  return (
    <footer className="border-t border-gray-200 py-10 text-sm text-gray-500 dark:border-gray-800 dark:text-gray-400">
      <div className="container mx-auto px-4">
        <div className="flex flex-col gap-6 md:flex-row md:items-center md:justify-between">
          <div>
            <div className="font-medium text-gray-900 dark:text-white">
              Stratistics
            </div>
            <div className="mt-1">
              <Trans>Advanced analytics for your Strava activities.</Trans>
            </div>
          </div>

          <div className="flex flex-wrap gap-x-6 gap-y-2">
            <Link
              to={DEMO_PATH}
              className="hover:text-gray-900 dark:hover:text-white"
            >
              <Trans>Demo</Trans>
            </Link>
            <Link
              to={HELP_PATH}
              className="hover:text-gray-900 dark:hover:text-white"
            >
              <Trans>Help</Trans>
            </Link>
            <Link
              to={FEEDBACK_PATH}
              className="hover:text-gray-900 dark:hover:text-white"
            >
              <Trans>Feedback</Trans>
            </Link>
            <Link
              to={PRIVACY_PATH}
              className="hover:text-gray-900 dark:hover:text-white"
            >
              <Trans>Privacy</Trans>
            </Link>
            <Link
              to={TERMS_PATH}
              className="hover:text-gray-900 dark:hover:text-white"
            >
              <Trans>Terms</Trans>
            </Link>
          </div>
        </div>

        <div className="mt-8 border-t border-gray-200 pt-6 text-center dark:border-gray-800">
          © {year} Stratistics. <Trans>All rights reserved.</Trans>
        </div>
      </div>
    </footer>
  );
}
